"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplianceRoutes = void 0;
const face_verification_1 = require("./face-verification");
const id_document_1 = require("./id_document");
const user_info_1 = require("./user_info");
const supplementary_document_1 = require("./supplementary_document");
const business_info_1 = require("./business_info");
const account_flags_1 = require("./account_flags");
const unified_edd_1 = require("./unified_edd");
const user_consent_1 = require("./user-consent");
const onfido_1 = require("./onfido");
class ComplianceRoutes {
    constructor() {
        this.faceVerification = new face_verification_1.FaceVerificationRoutes();
        this.idDocument = new id_document_1.IdDocumentRoutes();
        this.userInfo = new user_info_1.UserInfoRoutes();
        this.supplementaryDocument = new supplementary_document_1.SupplementaryDocumentRoutes();
        this.businessInfo = new business_info_1.BusinessInfoRoutes();
        this.flags = new account_flags_1.AccountFlagsRoutes();
        this.userConsent = new user_consent_1.UserConsentRoutes();
        this.onfido = new onfido_1.OnfidoRoutes();
        this.unifiedEdd = new unified_edd_1.UnifiedEddRoutes();
    }
}
exports.ComplianceRoutes = ComplianceRoutes;
//# sourceMappingURL=index.js.map